// extracted by mini-css-extract-plugin
module.exports = {"overlay":"GlobalLoading_overlay__zyeoJ","loader":"GlobalLoading_loader__BDDHh","loading":"GlobalLoading_loading__MAK2F"};